<app-engine [inputEnabled]="inputEnabled$ | async"></app-engine>
<router-outlet></router-outlet>
